import { MutationTree } from 'vuex';
import { ECreateResourceMutation } from './create-resource.constants';
import { ICreateResourceState } from '@/content-library/create-resource/store/create-resource.types';
import { IResource } from '@/api/resources/types/resource';

export const mutations: MutationTree<ICreateResourceState> = {
  [ECreateResourceMutation.SetState](state: ICreateResourceState, newState: ICreateResourceState) {
    state.savedResource = newState.savedResource;
    state.saving = newState.saving;
    state.loaded = newState.loaded;
    state.draft = newState.draft;
    state.loading = newState.loading;
  },
  [ECreateResourceMutation.SetLoading](state: ICreateResourceState, loading: boolean) {
    state.loading = loading;
  },
  [ECreateResourceMutation.SetLoaded](state: ICreateResourceState, loaded: boolean) {
    state.loaded = loaded;
  },
  [ECreateResourceMutation.SetSaving](state: ICreateResourceState, saving: boolean) {
    state.saving = saving;
  },
  [ECreateResourceMutation.SetSavedResource](state: ICreateResourceState, resource: IResource) {
    state.savedResource = resource;
  },
  [ECreateResourceMutation.SetDraft](state: ICreateResourceState, resource: IResource) {
    state.draft = resource;
  },
};
